import React from 'react'
import { formatPhoneNumber } from 'react-phone-number-input'
export interface PhoneNumberProps {
  phoneNumber: string
}

export const PhoneNumber: React.FC<PhoneNumberProps> = ({ phoneNumber }) => {
  return <span>{formatPhoneNumber(phoneNumber)}</span>
}
